"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateConfig = validateConfig;
var _error = require("./error");
var _coreUrl = _interopRequireDefault(require("../core-url"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Resize IFrame Handler
 * - resizes the SDK iframe
 *
 * @module core-bootstrap-config-validator
 */

/**
 * Validate the configuration object
 *
 * @param {*} config configuration object for this SDK instance
 * @return {boolean} true if valid, false otherwise
 */
function validateConfig(config) {
  if (!config) {
    return false;
  }
  if (config.brandIdentifier) {
    config.loadCustomCSS = true;
    config.loadCustomResourceBundle = true;
  } else {
    config.loadCustomCSS = false;
    config.loadCustomResourceBundle = false;
  }
  if (!config.targetDivId) {
    config.targetDivId = 'wells_card_offer';
  }
  if (!document.getElementById(config.targetDivId)) {
    (0, _error.handleError)('Cannot find targetDivId element #' + config.targetDivId, config);
    return false;
  }

  // validate the secureConfigurationUrl
  if (!config.secureConfigurationUrl) {
    (0, _error.handleError)('Configuration requires secureConfigurationUrl.', config);
    return false;
  }
  var parsedSecureConfigurationUrl = (0, _coreUrl["default"])(config.secureConfigurationUrl);
  if (parsedSecureConfigurationUrl.hostname !== 'localhost' && parsedSecureConfigurationUrl.hostname !== '10.0.2.2' && parsedSecureConfigurationUrl.hostname !== '127.0.0.1' && parsedSecureConfigurationUrl.protocol !== 'https:') {
    (0, _error.handleError)('The secureConfigurationUrl must use HTTPS or a local hostname' + ' (localhost, 10.0.2.2, or 127.0.0.1)', config);
    return false;
  }

  // rewrite the URL (converts relative into absolute)
  config.secureConfigurationUrl = parsedSecureConfigurationUrl.fullURL;

  // validate the SDK URL
  if (!config.sdkUrl) {
    (0, _error.handleError)('The internal sdkUrl is missing.', config);
    return false;
  }
  return true;
}
//# sourceMappingURL=validate-config.js.map